import RouteTemplate from 'ember-route-template';

import Component from '@glimmer/component';

import ErrorPage from 'rise-ui/components/error-page.gjs';

export default RouteTemplate(class HelpPageErrorTemplate extends Component {
  <template>
    <ErrorPage class="qa-error-help-page-not-found" as | error |>
      <error.title>Help Page Not Found</error.title>
      <error.subtitle>
        The help topic you selected does not exist. Please return to the Help page
        and search for the topic you are interested in or contact us for assistance.
      </error.subtitle>
    </ErrorPage>
  </template>
});
